import { createFileRoute } from "@tanstack/react-router";
import { ColorsIndex, colorsIndexHeadEn } from "@/pages/ColorsIndex";

export const Route = createFileRoute("/en/farver/")({
  head: colorsIndexHeadEn,
  component: ColorsIndex,
});
